import { Fragment, useEffect, useState } from 'react'

// components
import Header from '../components/Header/Header'
import CardList from '../components/CardList/CardList'
import AwardCard from '../components/AwardCard/AwardCard'
import Footer from '../components/Footer/Footer'

// utils
import groupBy from '../utils/groupBy'
import LoadMore from '../components/LoadMore/LoadMore'
import Seo from '../components/Seo/Seo'

const Awards = (props) => {
  const { page, metadata, awards } = props

  const [yearLimit, setYearLimit] = useState(2)

  useEffect(() => {
    document.querySelector('body').classList.add('is-generic')
    return () => {
      document.querySelector('body').classList.remove('is-generic')
    }
  }, [])

  return (
    <Fragment>
      <Seo {...metadata}/>
      
      <Header {...page.header[0]} />

      {awards.map((list, index) => {
        // do not render all years
        // @todo not sure if there isn't a better way of doing this but would say this will not be major unless there are thousands of awards
        if(index >= yearLimit) {
          return ``
        }

        return <CardList layout={`overview`} key={`CardList-${list.year}`} heading={list.year} type={`awards`}>
          {list.awards.map((award, index) => {
            return <AwardCard {...award} key={`Award-${award.id}`}/>
          })}
        </CardList>
      })}

      { awards.length > yearLimit &&
        <LoadMore onClick={() => { setYearLimit(yearLimit + 1) }} modifier={`is-left`} label="More awards"/>
      }

      <Footer/>

    </Fragment>
  )
}

export async function getServerSideProps (context) {
  const query = require('../queries/gqlAwards.graphql')

  // api endpoint
  let apiUrl = process.env.API_URL

  const queryData = {
    query
  }

  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(queryData)
  }

  // update api url to enable live and share preview
  if (context.query) {
    if (context.query.token && !!(context.query['x-craft-live-preview'] || context.query['x-craft-preview'])) {
      apiUrl = `${process.env.API_URL}?token=${context.query['token']}`
    }
  }

  const res = await fetch(apiUrl, opts)
  const json = await res.json()

  // group and order awards by year
  let awardsTmp = json.data.awards.map(item => {
    item.yearGroup = item.year[0].value
    return item
  })
  awardsTmp = groupBy(awardsTmp, 'yearGroup')

  // deconstruct the object and reverse its order
  let awardsPerYear = []
  Object.keys(awardsTmp).sort().reverse().forEach(year => {
    awardsPerYear.push({ year, awards: awardsTmp[year] })
  })

  return {
    props: {
      page: json.data.page,
      awards: awardsPerYear,
      metadata: {
        ...JSON.parse(json.data.metadata.metaTitleContainer).title,
        ...JSON.parse(json.data.metadata.metaTagContainer)
      }
    }
  }
}

export default Awards
